export default {
  hero: {
    eyebrow: "El centro de recursos de Basetao Spreadsheet",
    h1: "Basetao Spreadsheet: encuentra productos, compara vendedores y compra mejor",
    desc: "Explora recursos organizados de Basetao Spreadsheet, hallazgos de productos, guías de vendedores, información de QC, guías de envío, reseñas y consejos prácticos de compra — todo en un centro rápido y buscable.",
    secondary: "¿Buscas productos, revisas un vendedor, comparas opciones de envío o investigas si Basetao es legítimo? Empieza aquí.",
    trust: "Recurso independiente · Actualizado con regularidad · Enfocado en seguridad · Multilingüe",
  },
  popular: {
    title: "Temas populares",
  },
  value: {
    h2: "Todo lo que necesitas para entender Basetao",
    sub: "Un punto de partida claro y honesto para la investigación de productos, la verificación de vendedores y compras más seguras.",
    card1: {
      title: "Recursos Spreadsheet",
      desc: "Recursos de productos y categorías organizados para explorar hallazgos más rápido.",
    },
    card2: {
      title: "Investigación de vendedores",
      desc: "Aprende a comparar vendedores y evaluar la información del producto antes de pedir.",
    },
    card3: {
      title: "Guías de QC",
      desc: "Entiende las fotos QC y qué revisar antes de que se envíen tus artículos.",
    },
    card4: {
      title: "Guías de envío",
      desc: "Domina el peso, el peso volumétrico, las líneas de envío y el seguro.",
    },
    card5: {
      title: "Reseñas independientes",
      desc: "Artículos equilibrados sobre experiencia, tarifas, almacén y riesgos.",
    },
    card6: {
      title: "La seguridad primero",
      desc: "Detecta enlaces falsos, descuentos engañosos y solicitudes de pago riesgosas.",
    },
  },
  about: {
    h2: "¿Qué es Basetao Spreadsheet?",
    p1: "Basetao Spreadsheet se refiere a los recursos compartidos y organizados que las personas usan para descubrir productos, comparar vendedores y llevar un control de los artículos antes de hacer un pedido. Convierte enlaces de productos dispersos en un plan de compra más claro.",
    p2: "Como los datos de productos y vendedores cambian rápido, nos centramos en explicar cómo funcionan estos recursos y qué verificar — en lugar de presentar precios fijos o garantías.",
  },
  review: {
    h2: "¿Basetao es legítimo? Lee la evidencia antes de comprar",
    copy: "Nuestro contenido separa hechos, comentarios de usuarios y análisis editorial para que puedas decidir por ti mismo.",
    cta: "Leer la guía de legitimidad de Basetao",
  },
  shipping: {
    h2: "Costo de envío de Basetao: ¿qué afecta realmente el precio?",
    copy: "Los costos de envío pueden depender del destino, el peso, el peso volumétrico, la línea de envío, las dimensiones, el seguro y otros factores.",
    cta: "Aprende sobre los costos de envío",
  },
  safety: {
    h2: "Compra mejor. Verifica antes de pagar.",
    item1: "Verifica las URLs antes de hacer clic",
    item2: "Nunca compartas tus contraseñas",
    item3: "Revisa a los vendedores con cuidado",
    item4: "Verifica la evidencia del producto",
    item5: "Verifica los cupones",
    item6: "Entiende los términos de envío",
    cta: "Abrir la lista de seguridad",
  },
  articleSection: {
    h2: "Empieza con nuestra guía a fondo",
    copy: "¿Te preguntas si Basetao es legítimo y cómo mantenerte seguro? Lee nuestro artículo completo, escrito de forma independiente.",
    cta: "Leer el artículo completo",
  },
  guides: {
    h2: "Guías a fondo sobre Basetao",
    sub: "Diez guías originales e independientes sobre productos, vendedores, QC, envío, almacén, cupones, seguridad y comparaciones.",
  },
  cta: {
    h2: "¿Listo para explorar los recursos de Basetao Spreadsheet?",
    copy: "Empieza con la guía principal y luego explora productos, vendedores, QC, envío, reseñas y seguridad.",
    primary: "Basetao Spreadsheet",
    secondary: "Comprar ahora",
  },
};